/**
 * File header.js.
 */

(function ($) {
	'use strict';

	$(document).ready(function () {
		
		let above1200 = false;

		headerSizeSpace();
		// resize functions calls
		$(window).on('resize', function () {
			let windowWidth = $(window).width();
			headerSizeSpace();
			if (windowWidth >= 1200 && !above1200) {
				// Window size increased from below 1200px to 1200px or more
				above1200 = true;
				setTimeout(function(){
					headerSizeSpace();
				}, 300);
			} else if (windowWidth < 1200 && above1200) {
				// Window size decreased from above 1200px to below 1200px
				above1200 = false;
				setTimeout(function(){
					headerSizeSpace();
				}, 300);
			}
		});

		// return if link is #
		$(document).on('click', 'a[href="#"]', function () {
			return false;
		});

		// $('.site-header ul.primary-menu li.menu-item-has-children > a, .site-header ul.primary-menu > li.menu-item-has-megamenu > a').after('<i class="efi-angle-down submenu-toggle" aria-hidden="true"></i>');

		$(document).on('click', '.site-header .menu-toggle', function () {
			$('.site-header').toggleClass('toggled');
			$('body').toggleClass('off-scroll');
		});

		$(document).on('click', '.site-header ul.primary-menu li .submenu-toggle', function () {
			const windowWidth = $(window).outerWidth();
			if (1200 > windowWidth) {
				$(this).parent('li').toggleClass('active');
				$(this).siblings('.sub-menu, .children, .megamenu-wrap').slideToggle();
			}
		});

		$('.site-header ul.primary-menu li').hover(function () {
			const windowWidth = $(window).outerWidth();
			if (1199 < windowWidth && ($(this).hasClass('menu-item-has-megamenu') || $(this).hasClass('menu-item-has-children'))) {
				$(this).toggleClass('active').siblings().removeClass('active');
			}
		});

		$('.site-header .megamenu-wrap .megamenu-wrap__left ul > li').hover(function () {
			const windowWidth = $(window).outerWidth();
			if (1199 < windowWidth) {
				let dataReleated = $(this).data('related');
				$(this).addClass('active').siblings().removeClass('active');
				$(this).parents('.megamenu-wrap').find('.megamenu-wrap__item_details').each(function () {
					let dataTabId = $(this).data('tab-id');
					if (dataTabId === dataReleated) {
						$(this).addClass('active');
					} else {
						$(this).removeClass('active');
					}
				});
			}
		});

		$(document).on('click', '.site-header__language-action', function () {
			$('.site-header__languages-list').toggle();
		});

		$(document).on('click', function (e) {
			if (!$(e.target).closest('.site-header__languages-list').length && !$(e.target).closest('.site-header__language-action').length) {
				$('.site-header__languages-list').hide();
			}
		});

		$('.search-form').submit(function (e) {
            // Get the value from the search input field

            let searchValue = $(this).parent().find('.search-field').val();
            // Check if the search value has at least 3 characters
            if (searchValue.length < 3) {
                // Prevent the form from submitting
                e.preventDefault();

                // Insert the error message dynamically
                $(this).parents( '.search-form-wrapper' ).find('.error-message').show();
            } else {
                // Clear any previous error messages
                $(this).parents( '.search-form-wrapper' ).find('.error-message').hide();
            }
		});

		// Sticky Header
		$(window).scroll(function () {
			if ($(window).scrollTop() >= 80) {
				$('.site-header').addClass('fixed-header');
			} else {
				$('.site-header').removeClass('fixed-header');
			}
		});
	});

	function headerSizeSpace() {
		let header = $('.site-header');
		if (0 < header.length) {
			$('.site-main').css('padding-top', header.outerHeight());
			let headerMenu = header.find('.efi-menu');
			let windowWidth = $(window).width();
			if (0 < headerMenu.length) {
				if ( windowWidth < 1200 ) {
					if( $('body').hasClass('admin-bar') ) {
						headerMenu.css('top', header.outerHeight() + $('#wpadminbar').outerHeight());
					} else {
						headerMenu.css('top', header.outerHeight());
					}
				} else {
					headerMenu.css('top', '');
				}
			}
		}
	}

	let notifyFontColor = $('.site-header-notification').attr('data-font-color') ? $('.site-header-notification').attr('data-font-color') : '';

	if ( '' != notifyFontColor ) {
		$('.site-header-notification p').css('color', notifyFontColor);
		$('.site-header-notification a').css('color', notifyFontColor);
		$('.site-header-notification span').css('color', notifyFontColor);
	}

})(jQuery);
